import _sfc_main from "/home/runner/work/lnxdxtf.dev/lnxdxtf.dev/src/xp/XpWindow.vue?vue&type=script&setup=true&lang.ts";
export * from "/home/runner/work/lnxdxtf.dev/lnxdxtf.dev/src/xp/XpWindow.vue?vue&type=script&setup=true&lang.ts";
import "/home/runner/work/lnxdxtf.dev/lnxdxtf.dev/src/xp/XpWindow.vue?vue&type=style&index=0&scoped=a35f393a&lang.css";
import _export_sfc from "\0plugin-vue:export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-a35f393a"]]);
